import axios from 'axios'
import env from "../../env"
import Swal from 'sweetalert2'

export const newBroadcast = (data) => {
  // Swal.fire({
  //   title: 'Processing...',
  //   html: 'Please wait...',
  //   allowEscapeKey: false,
  //   allowOutsideClick: false,
  //   didOpen: () => {
  //     Swal.showLoading()
  //   }
  // });  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING_BC', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/bc-whatsapp/${env.SOURCE}/send`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data
        })
          .then(response => {
            console.log(response.data);
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR_BC', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING_BC', payload: false })
          })
    }
}


export const fetchTemplates = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/bc-whatsapp/template`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        })
          .then(response => {
            dispatch({ type: 'SET_TEMPLATES', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchTemplate = (id) => {  
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADING', payload: true })
        axios({
            method:'get',
            url: `${env.REACT_APP_BE_URL}/bc-whatsapp/template/${id}`,
            headers: {
              authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
          })
            .then(response => {
              dispatch({ type: 'SET_TEMPLATE', payload: response.data})
            })
            .catch(error => {
              dispatch({ type: 'SET_ERROR', payload: error})
            })
            .finally(_ => {
              dispatch({ type: 'SET_LOADING', payload: false })
            })
      }
}  

export const fetchGroups = () => {  
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADING', payload: true })
        axios({
            method:'get',
            url: `${env.REACT_APP_BE_URL}/bc-whatsapp/contactGroup`,
            headers: {
              authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
          })
            .then(response => {
              dispatch({ type: 'SET_GROUPS', payload: response.data})
            })
            .catch(error => {
              dispatch({ type: 'SET_ERROR', payload: error})
            })
            .finally(_ => {
              dispatch({ type: 'SET_LOADING', payload: false })
            })
      }
}

export const fetchContacts = () => {  
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADING', payload: true })
        axios({
            method:'get',
            url: `${env.REACT_APP_BE_URL}/bc-whatsapp/contactList`,
            headers: {
              authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
          })
            .then(response => {
              dispatch({ type: 'SET_CONTACTS', payload: response.data})
            })
            .catch(error => {
              dispatch({ type: 'SET_ERROR', payload: error})
            })
            .finally(_ => {
              dispatch({ type: 'SET_LOADING', payload: false })
            })
      }
}

export const setContactGroup = (payload) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/bc-whatsapp/newContactGroup`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data: payload
        })
          .then(response => {
            dispatch({ type: 'SET_CONTACTS', payload: response.data})
            dispatch({ type: 'SET_PROGRESS_STATUS', payload: true})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
            dispatch({ type: 'SET_PROGRESS_STATUS', payload: false})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const resetProgress = (payload) => {  
  return (dispatch, getState) => {
    dispatch({ type: 'SET_PROGRESS_STATUS', payload: false})
  }
}

export const newPdfTemplate = (data) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/bc-template/newPdf`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data
        })
          .then(response => {
            // dispatch({ type: 'SET_TEMPLATES', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const newImageTemplate = (data) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/bc-template/newImage`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data
        })
          .then(response => {
            // dispatch({ type: 'SET_TEMPLATES', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const newTextTemplate = (data) => {
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/bc-template/newText`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data
        })
          .then(response => {
            console.log(response.data);
            // dispatch({ type: 'SET_TEMPLATES', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const showBroadcastStatisticSummaries = (data) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_BC_STATS', payload: {}})
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/bc-whatsapp/reportSummaries`,
      data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })
      .then(response => {
        if (response.data.message === 'Log data not found') {
          dispatch({ type: 'SET_BC_STATS', payload: {}})
        }
        dispatch({ type: 'SET_BC_STATS', payload: response.data})
      })
      .catch(error => {
        console.log(error,'<<<<');
      })
      .finally(_ => {
      })
    }
}
